import {
  TikTokFilled,
  FacebookSquare,
  LinkedInSquare,
  YouTube,
} from '@sparemin/blockhead';
import { SocialPlatform } from 'api';
import { InstagramIcon, ThreadsIcon, XIcon } from 'assets/icons';

type SocialPlatformInfo = {
  icon: React.ReactElement;
  brandName: string;
};

export const socialPlatformInfoLookup: Record<
  SocialPlatform,
  SocialPlatformInfo
> = {
  linkedin: {
    icon: <LinkedInSquare width="24px" height="24px" />,
    brandName: 'LinkedIn',
  },

  youtube: {
    icon: <YouTube width="29px" height="20px" />,
    brandName: 'YouTube',
  },
  tiktok: {
    icon: <TikTokFilled width="20px" height="23px" />,
    brandName: 'TikTok',
  },
  twitter: {
    icon: <XIcon color="#000" width="24px" height="20px" />,
    brandName: 'Twitter',
  },
  facebook: {
    icon: <FacebookSquare width="24px" height="24px" />,
    brandName: 'Facebook',
  },
  instagram: {
    icon: <InstagramIcon width="24px" height="24px" />,
    brandName: 'Instagram',
  },
  threads: {
    icon: <ThreadsIcon width="24px" height="28px" />,
    brandName: 'Threads',
  },
};
